import { render } from "./AppLayoutSpinner.vue?vue&type=template&id=132a05cb&scoped=true"
import script from "./AppLayoutSpinner.vue?vue&type=script&lang=js"
export * from "./AppLayoutSpinner.vue?vue&type=script&lang=js"

import "./AppLayoutSpinner.vue?vue&type=style&index=0&id=132a05cb&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132a05cb"]])

export default __exports__